import { Container, Box, Typography, TextField } from "@mui/material";
import { Grid } from "@mui/material";


const ThirdSection = () => {
  return (
    <Grid
      container
      sx={{
        padding: "10% 10% 10% 10%",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Grid sx={{ display: "flex", flexDirection: "row" }}>
          <Grid>
            <img src="./img/underline.svg" width="50px" height="65px" />
          </Grid>
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: "Poppins",
              fontSize: { md: "40px", xs: "50px", sm: "60px" },
              lineHeight: "60px",
              ml: "30px",
            }}
          >
            Get Credits
          </Typography>
        </Grid>
        <Grid>
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: "Poppins",
              fontSize: { md: "16px", sm: "28px", xs: "28px" },
              lineHeight: { md: "24px", sm: "32px", xs: "28px" },
            }}
          >
            Refer your friends
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: "Poppins",
              fontSize: { md: "16px", sm: "28px", xs: "36px" },
              lineHeight: "24px",
            }}
          >
            Get Free NFTs Referring friends
          </Typography>
        </Grid>
        <Grid container sx={{ display: "flex", flexDirection: "row" }}>
          <img style={{ marginTop: "30px" }} src="./img/iconGroup.svg"></img>
          <Grid sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              sx={{
                marginTop: "25px",
                fontWeight: 600,
                fontFamily: "Poppins",
                marginLeft: { md: "20px", sm: "20px", xs: "20px" },
                fontSize: { md: "20px", sm: "20px", xs: "20px" },
                lineHeight: "30px",
              }}
            >
              Following Social Media
            </Typography>
            <Typography
              sx={{
                fontWeight: 600,
                fontFamily: "Poppins",
                fontSize: { md: "14px", sm: "20px", xs: "20px" },
                marginLeft: { md: "20px", sm: "20px", xs: "20px" },
                lineHeight: "21px",
              }}
            >
              Friends follow twitter + Joins Discord{" "}
            </Typography>

            <Typography
              sx={{
                marginTop: "65px",
                fontWeight: 600,
                fontFamily: "Poppins",
                marginLeft: { md: "20px", sm: "20px", xs: "20px" },
                fontSize: { md: "20px", sm: "20px", xs: "20px" },
                lineHeight: "30px",
              }}
            >
              Minting NFTs{" "}
            </Typography>
            <Typography
              sx={{
                marginLeft: "20px",
                fontWeight: 600,
                fontFamily: "Poppins",
                fontSize: { md: "14px", sm: "18px", xs: "20px" },
                marginLeft: { md: "20px", sm: "18px", xs: "20px" },
                lineHeight: "21px",
              }}
            >
              Friends mint 4 NFTs in MDTP & sets contents{" "}
            </Typography>

            <Typography
              sx={{
                marginTop: "65px",
                marginLeft: { md: "20px", sm: "20px", xs: "20px" },
                fontSize: { md: "20px", sm: "20px", xs: "20px" },
                fontWeight: 600,
                fontFamily: "Poppins",
                lineHeight: "30px",
              }}
            >
              Admin Panel{" "}
            </Typography>
            <Typography
              sx={{
                marginLeft: "14px",
                fontSize: { md: "14px", sm: "18px", xs: "20px" },
                marginLeft: { md: "20px", sm: "18px", xs: "20px" },
                fontWeight: 600,
                fontFamily: "Poppins",
                lineHeight: "21px",
              }}
            >
              Inform admins on Discord with proof{" "}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        sx={{ display: "flex", textAlign: "center", justifyContent: "center" }}
      >
        <img
          style={{ width: "100%", transform: "translate(0%, -0%)" }}
          src="./img/rotate.svg"
        ></img>
      </Grid>
    </Grid>
  );
};
export default ThirdSection;
